/**
 * Built-in mission harness template defaults (mirrors integrations-service
 * MissionTemplateCatalog).
 */

export const DEFAULT_WAKE_MESSAGE =
  "Continue working toward the mission objective. If it is complete, finish the mission; otherwise take the next step.";

export const MISSION_AGENT_TEMPLATES = [
  {
    value: "standard_agent",
    label: "Standard agent",
    description:
      "Daily heartbeat, objective-met stop with safety caps, auto completion.",
  },
];

export const STOP_UNTIL_LABELS = {
  MANUAL: "Manual stop only",
  OBJECTIVE_MET: "Objective met (with safety caps)",
  BINDING_TERMINAL: "Bound resource terminal",
  MAX_DURATION: "Maximum duration",
  MAX_TURNS: "Maximum turns",
  END_AT: "End at scheduled time",
};

export const COMPLETION_MODE_LABELS = {
  AUTO: "Auto — agent calls complete_mission",
  CONFIRM: "Confirm — human approves completion",
  MANUAL: "Manual — user completes the mission",
};

/** Built-in template policy snapshots keyed by templateId. */
export const MISSION_TEMPLATE_POLICIES = {
  standard_agent: {
    wakePolicy: {
      heartbeat: {
        enabled: true,
        cadence: "PT24H",
        timezone: null,
        daysOfWeek: [],
        timeOfDay: null,
        message: DEFAULT_WAKE_MESSAGE,
      },
      scheduledWakes: [],
      eventWakes: [],
      noProgressDeadline: null,
      customDeadlines: [],
      debounceMs: null,
      cooldownMs: null,
      maxTurnsPerHour: 5,
      skipIfSubjectRunning: true,
    },
    stopPolicy: {
      until: {
        kind: "OBJECTIVE_MET",
        maxTurns: 100,
        maxDuration: "P30D",
      },
      completionMode: "AUTO",
    },
    turnPolicy: {
      maxIterations: 50,
      wakeMessage: DEFAULT_WAKE_MESSAGE,
      allowAgentReschedule: false,
      postCheckToTranscript: true,
    },
  },
};

export function resolveMissionTemplatePolicy(templateId) {
  const id = templateId || "standard_agent";
  return MISSION_TEMPLATE_POLICIES[id] || MISSION_TEMPLATE_POLICIES.standard_agent;
}
